import { createSlice } from "@reduxjs/toolkit";
import {
  closeOnBoarding,
  setOnBoardingValue,
  setOnBoardingValues,
} from "domain/on-boarding/on-boarding.actions";

export type OnBoardingState = {
  closedWelcomeMessage: boolean;
  closedObjectiveAdvice: boolean;
  closedDownloadAdvice: boolean;
  closedDownloadActivityImages: boolean;
  closedAISearchTooltip: boolean;
  closedVisualSupportsTooltip: boolean;
};

const initialState: OnBoardingState = {
  closedWelcomeMessage: false,
  closedObjectiveAdvice: false,
  closedDownloadAdvice: false,
  closedDownloadActivityImages: false,
  closedAISearchTooltip: false,
  closedVisualSupportsTooltip: false,
};

export const onBoardingSlice = createSlice({
  name: "onBoarding",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //SET ONBOARDING VALUE
    builder.addCase(setOnBoardingValue.fulfilled, (state, action) => {
      state[action.payload.type] = action.payload.value;
    });
    //SET ONBOARDING VALUES
    builder.addCase(setOnBoardingValues.fulfilled, (state, action) => {
      Object.assign(state, action.payload);
    });
    //CLOSE ONBOARDING
    builder.addCase(closeOnBoarding.fulfilled, (state, action) => {
      state[action.payload] = true;
    });
  },
});
